import request from '@/utils/request';

import type { FetchComingSoonResp } from './coming-soon.data';

export async function fetchComingSoons(params?: any): Promise<FetchComingSoonResp> {
  return request.get('/coming-soons', {
    params,
  });
}

export async function createComingSoon(params: any) {
  return request.post(`/coming-soons`, {
    data: params,
  });
}
